import React from "react";
import { injectIntl } from "react-intl";

function BranchPinItem({intl, branchData}) {
  return(
    <li>
      <div data-rs-map-marker={`${branchData.lat},${branchData.lng}`}>
        <h3 className="popup-bubble__title">{branchData.title}</h3>
        <address className="popup-bubble__address text--alternative">
          <div>{`${branchData.address_line1 || ""}`}</div>
          <div>{`${branchData.postal_code || ""}`}</div>
          <div>{`${branchData.locality_1 || ""}`}</div>
          { branchData.main_office_phone && (
          <a href={`tel:${branchData.main_office_phone}`}>{branchData.main_office_phone}</a>)
          }
          <a className="popup-bubble__route_link" href={`https://maps.google.com/maps?daddr=${branchData.lat},${branchData.lng}`} target="_blank" rel="noopener noreferrer">
            { intl.formatMessage({id: "BranchPinItem.ShowDirections"}) }
          </a>
        </address>
        <a className="popup-b ubble__details-link" href={branchData.url}>{ intl.formatMessage({id: "BranchPinItem.ViewDetails"}) }</a>
      </div>
    </li>
  )
}

export default injectIntl(BranchPinItem);
